export class ThrusterType {

    public uid: string;
    public type: string;
    public subtype: string;
    public description: string;
}
